module.exports = __webpack_public_path__ + "img/cateicon2_a.913eb56d.svg";